

























import {Component, Vue} from 'vue-property-decorator';

import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";
import {CreateTraineeRequestModel} from "@/domain/trainees/CreateTraineeRequestModel";

import {getAuthenticationClient} from '@/authentication/getAuthenticationClient';

@Component({})

export default class createTrainee extends Vue {

    private grade: number = 1;
    private name: string | null = null;
    private busy: boolean = false;

    async mounted() {
    }

    async createTrainee() {
        if (!this.busy && this.grade && this.name) {
            this.busy = true;


            const request = new CreateTraineeRequestModel(this.name, this.grade);

            try {
                await traineesClient.createTrainee(request);

                await this.$router.back();
            } finally {
                this.busy = false;
            }
        }
    }
}

